import { createApp } from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import './index.css';
import '@fortawesome/fontawesome-free/css/all.css';
import 'vue-toastification/dist/index.css';
import Toast, { POSITION } from 'vue-toastification';
import { createVuetify } from 'vuetify';
import 'vuetify/styles';
import '@mdi/font/css/materialdesignicons.css';
import apiInterceptor from './plugins/apiInterceptor';

const options = {
  position: POSITION.TOP_RIGHT,
  timeout: 3000,
  hideProgressBar: true,
};

const vuetify = createVuetify();

// VERIFICAÇÃO ESPECIAL: Se estiver na página /blocked, NÃO FAZER NADA
if (window.location.pathname === '/blocked') {
  console.log('Página /blocked detectada. Carregando normalmente sem verificações.');
  // NÃO FAZER ABSOLUTAMENTE NADA - deixar a página carregar normalmente
} 
// Caso contrário, verificar bloqueio normalmente
else {
  // Verificar cookies de bloqueio
  const isBlocked = localStorage.getItem('ipBlocked') === 'true' || 
    document.cookie.split(';').some(function(cookie) {
      return cookie.trim().startsWith('dale_blocked=1');
    });
  
  // Se bloqueado, redirecionar para /blocked
  if (isBlocked) {
    console.warn('IP BLOQUEADO: Redirecionando para /blocked');
    window.location.replace('/blocked');
  }
}

// Criar a aplicação Vue
const app = createApp(App);

// Adicionar propriedade global para verificar se IP está bloqueado
app.config.globalProperties.$isIpBlocked = () => {
  return localStorage.getItem('ipBlocked') === 'true';
};

// Mixin global removido para evitar redirecionamentos em loop
// Agora a verificação de bloqueio acontece apenas uma vez no carregamento inicial

// Montar o aplicativo apenas se ainda não houver bloqueio
app
  .use(store)
  .use(Toast, options)
  .use(router)
  .use(vuetify)
  .use(apiInterceptor)
  .mount('#app');
